import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-patient-info-list',
  templateUrl: './patient-info-list.component.html',
  styleUrls: ['./patient-info-list.component.css']
})
export class PatientInfoListComponent implements OnInit {

  constructor() { }
  @Input() title;
  @Input() info;

  ngOnInit() {
  }

}
